import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const sourceCodeHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 200 },
    children: [
        new TextRun({
            text: "Information Gathering",
            size: 24,
            color: "003366",
            font: "Calibri",
            bold: true,
            italics: false
        })
    ],
})
export const sourceCodeTextOne = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Source code review process involves both manual and automated code review. In the automated review process, most of the tools capture the static security issues in the code and produce good amount of low critical findings and warning. Automated tool also helps in capturing developer’s comments inside the code where sometime sensitive information is hard coded.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeTextTwo = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Critical code segments identified during the review planning phase goes through rigorous manual review process. code review checklist and the application threat profile document form the basis for conducting the manual review process. Team verifies the findings reported by the tools prioritized them based on their criticality and impact.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})
export const sourceCodeTextThree = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Manual review of the source code would be carried out to identify any malicious code which may exploit the application or make it behave against the intended functionality. Manual review of the application would be carried out on the following areas:",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletOne = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Weak Input data validation ",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletTwo = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "SQL injection",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletThree = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Authentication routines",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletFour = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Authorization routines",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletFive = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Improper session management",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletSix = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Improper error handling mechanism",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})
export const sourceCodeBulletSeven = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Insecure configuration management",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletEight = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Database Connectivity routines",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletNine = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Data security / encryption routines",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletTen = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Hard coded authentication credentials ",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletEleven = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Audit and logging routines",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const sourceCodeBulletTwelve = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Critical business function routines",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})
export const sourceCodeBulletThirtteen = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1400, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Undocumented interfaces",
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})
